module.exports = __webpack_public_path__ + "images/ssoIcon-bb253be32a967bd0fbe7a8bb8e30bc95.svg";